import { CheckboxUI } from '../Interface';
import { useFormikContext } from 'formik';

const ResourceOneUserLinks = ({ disabled }) => {
  const { values, setFieldValue } = useFormikContext();

  const updateResourceOneUserLink = (resourceOneId, isChecked) => {
    const updatedLinks = values?.resourceOneUserLink?.map((link) =>
      link.id === resourceOneId ? { ...link, checked: isChecked } : link
    );
    setFieldValue('resourceOneUserLink', updatedLinks);
  };

  return (
    <div>
      {values?.resourceOneUserLink?.map((resourceOneLink) => (
        <div key={resourceOneLink.id}>
          <CheckboxUI
            sx={{ margin: 0, padding: '0.2rem' }}
            disabled={disabled}
            onChange={(e) => updateResourceOneUserLink(resourceOneLink.id, e.target.checked)}
            checked={resourceOneLink.checked || false}
          />
          {resourceOneLink.name}
        </div>
      ))}
    </div>
  );
};

export default ResourceOneUserLinks;
